import { atomWithStorage } from 'jotai/utils';

export const preferencesAtom = atomWithStorage('webportal_preferences', {
    sidebarOpen: false,
    showChartLabels: false,
});

export default 0;
